import React, { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import * as datefns from 'date-fns'
import { DEPLOY_INFO_BRANCH_NAME, DEPLOY_INFO_TIME } from '../../../../constants'
import DeployInfoApi, { DeployInfoType } from '../../../../api/DeployInfoApi'

const deployInfoApi = new DeployInfoApi()

export function DeployInfo() {
    const [serverDeployInfo, setServerDeployInfo] = useState<DeployInfoType>({
        branchName: 'unknown',
        deployTime: null,
    })

    useEffect(() => {
        deployInfoApi
            .getServerDeployInfo()
            .then((deployInfo) => {
                setServerDeployInfo(deployInfo)
            })
            .catch((err) => console.error(err))
    }, [])

    return (
        <>
            <Stack
                direction='column'
                spacing={2}
                sx={{
                    alignItems: 'left',
                }}
            >
                <Typography variant='caption'>
                    Webklient deployad senast:{' '}
                    <strong>
                        {DEPLOY_INFO_TIME ? datefns.format(new Date(DEPLOY_INFO_TIME), 'yyyy-MM-dd HH:mm:ss') : '?'}
                    </strong>
                    . {}
                    Körs från branch <strong>{DEPLOY_INFO_BRANCH_NAME || '?'}</strong>.
                </Typography>
                {serverDeployInfo && (
                    <Typography variant='caption'>
                        Server deployad senast:{' '}
                        <strong>
                            {serverDeployInfo.deployTime
                                ? datefns.format(new Date(serverDeployInfo.deployTime), 'yyyy-MM-dd HH:mm:ss')
                                : '?'}
                        </strong>
                        . Körs från branch <strong>{serverDeployInfo.branchName || '?'}</strong>.
                    </Typography>
                )}
            </Stack>
        </>
    )
}
